import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Signal01 = function Signal01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M16.2426 7.7574c2.3432 2.3431 2.3432 6.1421 0 8.4853m-8.4852-.0001c-2.3432-2.3431-2.3432-6.1421 0-8.4852M4.9289 19.071c-3.9052-3.9053-3.9052-10.2369 0-14.1421m14.1422 0c3.9052 3.9052 3.9052 10.2369 0 14.1421M14 12c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8955 2 2"
    })
  }));
};
export default Signal01;